function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.5308 6.01614L12.234 2.03031C12.0826 1.97688 11.9175 1.97688 11.7661 2.03031L0.469219 6.01614C0.188344 6.11523 0.000375562 6.38055 5.61892e-07 6.67839C-0.000374438 6.97623 0.186985 7.24197 0.467626 7.34172L11.7645 11.3578C11.8407 11.3849 11.9204 11.3985 12 11.3985C12.0797 11.3985 12.1593 11.3849 12.2355 11.3578L23.5324 7.34172C23.813 7.24197 24.0003 6.97623 24 6.67839C23.9996 6.38055 23.8117 6.11523 23.5308 6.01614Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.3115 15.4027V9.26953L20.9053 9.76945V15.4027C20.4817 15.6465 20.1963 16.1033 20.1963 16.6271C20.1963 17.1509 20.4817 17.6077 20.9053 17.8515V21.3069C20.9053 21.6953 21.2201 22.0101 21.6084 22.0101C21.9967 22.0101 22.3115 21.6953 22.3115 21.3069V17.8515C22.7351 17.6078 23.0205 17.1509 23.0205 16.6271C23.0205 16.1033 22.7351 15.6465 22.3115 15.4027Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9991 12.8054C11.7577 12.8054 11.52 12.7644 11.2925 12.6835L4.94177 10.4258V13.5199C4.94177 14.2769 5.73148 14.9171 7.28894 15.4226C8.64649 15.8632 10.3193 16.1059 11.9991 16.1059C13.6789 16.1059 15.3516 15.8632 16.7092 15.4226C18.2667 14.9171 19.0564 14.2769 19.0564 13.5199V10.4258L12.7057 12.6835C12.4781 12.7644 12.2404 12.8054 11.9991 12.8054Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgHat = function SvgHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hat.0cecd62e.svg";
export { ForwardRef as ReactComponent };